import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Confirm before leaving via browser back/forward. Compatible with BrowserRouter
 * (useBlocker only works with data routers like createBrowserRouter).
 *
 * @param {boolean} when - Whether navigation should be guarded
 * @param {string} message - Confirm dialog text
 * @param {() => void} [onConfirm] - Side effects to run when the user confirms leave
 */
export const useNavigationGuard = (when, message, onConfirm) => {
  const navigate = useNavigate();
  const messageRef = useRef(message);
  const onConfirmRef = useRef(onConfirm);

  messageRef.current = message;
  onConfirmRef.current = onConfirm;

  useEffect(() => {
    if (!when) return;

    window.history.pushState({ navigationGuard: true }, '', window.location.href);

    const handlePopState = () => {
      const confirmed = window.confirm(messageRef.current);
      if (confirmed) {
        onConfirmRef.current?.();
        navigate('/admin/urstudio');
      } else {
        window.history.pushState({ navigationGuard: true }, '', window.location.href);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [when, navigate]);
};
